export const PROD = true;

// export const MAIN_URL = PROD ? 'https://app.buff.game/api' : 'https://core-tst.app.buff.game/api';
// export const SOCKET_URL = PROD ? 'https://app.buff.game/' : 'https://core-tst.app.buff.game/';

export const MAIN_URL = PROD ? 'https://app.buff.game/api' : 'https://core-stg.app.buff.game/api';
export const SOCKET_URL = PROD ? 'https://app.buff.game/' : 'https://core-stg.app.buff.game/';

// export const MAIN_URL = PROD ? 'https://app.buff.game/api' : 'https://dev.app.buff.game/api';
// export const SOCKET_URL = PROD ? 'https://app.buff.game' : 'https://dev.app.buff.game';
